import React, { useContext } from 'react'
import { Link, NavLink } from 'react-router-dom'
import {FaTumblr} from 'react-icons/fa'
import { useState } from 'react'
import {IoIosClose,IoIosMail } from 'react-icons/io'
import {FcGoogle } from 'react-icons/fc'
import {MdHomeFilled} from 'react-icons/md'
import {AiFillApple, AiOutlineArrowLeft, AiFillShop, AiOutlineSearch } from 'react-icons/ai'
import {GiHamburgerMenu} from "react-icons/gi"
import {FiCompass} from 'react-icons/fi'
import {GoMail} from 'react-icons/go'
import {BsFillLightningChargeFill} from 'react-icons/bs'
import {CiUser} from 'react-icons/ci'
import {RiChatSmile3Line} from 'react-icons/ri'
import {GrEdit} from 'react-icons/gr'
import logo from '../img/cbLogo.png'
import axios from 'axios'
import { BlogContext } from './context.js/BlogContext'
import MyModal from './PostModal'
import CreatePostImg from './CreatePostImg'
import CreateQuotePost from './CreateQuotePost'
import CreateLinkPost from './CreateLinkPost'
import CreateHiChatPost from './CreateHiChatPost'
import CreateAudioPost from './CreateAudioPost'
import CreateVidPost from './CreateVidPost'


export default function Navigation() {
  const [loginIsShown,setLoginIsShown]=useState(false);
  const [loginHide,setLoginHide]=useState(false);
  const [signUpIsShown,setSignUpisShown]=useState(false);
  const [signUpHide,setSignUpHide]=useState(false);
  const [createPostIsShown,setCreatePostIsShown]=useState(false)
  const {isloggedIn}=useContext(BlogContext)

const url ="https://tumblr-api.cyclic.app/";

const [loginInput,setLoginInput]= useState({ email:"", password:"",})

const [signUpData,setSignUpData]=useState({
  email:"",
  password:"",
  name:"",
  phone:"",
  image:""
})



const signUpForm= new FormData();

signUpForm.append("name",signUpData.email)
const [isEmpty,setIsEmpty]= useState(false);


const handleLoginPopup=()=>{
  setLoginIsShown(current=>!current)
}

const handleSignUpPopup=()=>{
  setSignUpisShown(current=>!current)
}
const handleNewPostPopup=()=>{
  setCreatePostIsShown(current=>!current)
}

 


  return (
<>


{loginIsShown&&(

  <div className="container-fluid overlay">

<div className="popup p-4 m-auto col-lg-6 col-md-10 col-sm-12 rounded-3 mt-2" style={{    backgroundColor: "#7C5CFF"}}> 
<div className="d-flex justify-content-between">


{loginHide===true?(               <Link className='text-dark fw-bolder' onClick={()=>{
setLoginHide(false)
}}>
<AiOutlineArrowLeft/>
                  
                </Link>):null}

<Link
                  onClick={() => {
                    setLoginIsShown(false);
                  }}
                  className=" text-black fs-4 text-decoration-none"
                >
                 <IoIosClose />{" "}
                </Link>





                </div>

<div className="content text-center" style={{display:loginHide===true?"none":"block"}}>
<h1 className='text-white fw-bolder'>tumblr</h1>
<p className='text-light'> 
Welcome yo your corner of the internet. You'll never be bored again
</p>

<p className='fs-4 fw-bold'>
Sign up or log in:
</p>

<p>
By continuing, you agree to our <Link className='text-light'> Terms of Service </Link> <br />
 and read our <Link> Privacy Policy</Link> .
</p>
<div className="links d-block text-center">
<button className='bg-light btn border-0 text-dark rounded-5   disabled justify-content-center align-content-center 
' 

> <span className='fs-6'><FcGoogle /></span>
Continue with Google
</button>
<br />

<button className='bg-light btn border-0 text-dark rounded-5    disabled justify-content-center align-content-center mt-2'>
<span className='fs-5'><AiFillApple /></span> 
Continue with Apple 
</button>
 <br />
<button className='bg-light btn border-0 text-dark rounded-5    justify-content-center align-content-center mt-2'
onClick={()=>{
setLoginHide(true)
}}
>
<span className='fs-5'><IoIosMail /></span>
Continue with email  
</button>

</div>

</div>
{loginHide&&(
  <div className="content signInHide text-center" style={{display:loginHide===true?"block":"none"}}>
<h1 className='text-white fw-bolder'>tumblr</h1>
<p className='text-light'> 
Welcome yo your corner of the internet. You'll never be bored again
</p>

<p className='fs-4 fw-bold'>
Enter your email to register
</p>

<form action=" " className='col-6 m-auto'>
<input
value={loginInput.email}
onChange={(e)=>{
  setLoginInput({...loginInput,email:e.target.value})
}}
 className='border-0 rounded-4 form-control' type="email" placeholder='email' />
<input
value={loginInput.password}
onChange={(e)=>{
  setLoginInput({...loginInput,password:e.target.value})
}}

 className='border-0 rounded-4 form-control mt-2' type="password" placeholder='password' />
<button 
onClick={(e)=>{
  e.preventDefault()
//  handleLogin()

}}
 className='btn btn-success mt-2'>Login</button>
</form>


</div>
)}







</div>
</div>

)}



{signUpIsShown&&(

<div className="container-fluid overlay">

<div className="popup p-4 m-auto col-lg-6 col-md-10 col-md-12 rounded-3 mt-2" style={{    backgroundColor: "#7C5CFF"}}> 
<div className="d-flex justify-content-between">


{signUpHide===true?(               <Link className='text-dark fw-bolder' onClick={()=>{
setSignUpHide(false)
}}>
<AiOutlineArrowLeft/>
                
              </Link>):null}

<Link
                onClick={() => {
                  setSignUpisShown(false);
                }}
                className=" text-black fs-4 text-decoration-none"
              >
               <IoIosClose />{" "}
              </Link>





              </div>

<div className="content text-center" style={{display:signUpHide===true?"none":"block"}}>
<h1 className='text-white fw-bolder'>tumblr</h1>
<p className='text-light'> 
Welcome yo your corner of the internet. You'll never be bored again
</p>

<p className='fs-4 fw-bold'>
Sign up or log in:
</p>

<p>
By continuing, you agree to our <Link className='text-light'> Terms of Service </Link> <br />
and read our <Link> Privacy Policy</Link> .
</p>
<div className="links d-block text-center">
<button className='bg-light btn border-0 text-dark rounded-5   disabled justify-content-center align-content-center 
' 

> <span className='fs-6'><FcGoogle /></span>
Continue with Google
</button>
<br />

<button className='bg-light btn border-0 text-dark rounded-5    disabled justify-content-center align-content-center mt-2'>
<span className='fs-5'><AiFillApple /></span> 
Continue with Apple 
</button>
<br />
<button className='bg-light btn border-0 text-dark rounded-5    justify-content-center align-content-center mt-2'
onClick={()=>{
setSignUpHide(true)
}}
>
<span className='fs-5'><IoIosMail /></span>
Continue with email  
</button>

</div>

</div>
{signUpHide&&(
<div className="content signInHide text-center" style={{display:signUpHide===true?"block":"none"}}>
<h1 className='text-white fw-bolder'>tumblr</h1>
{/* <p className='text-light'> 
Welcome yo your corner of the internet. You'll never be bored again
</p> */}

<p className='fs-4 fw-bold'>
Enter your email to register
</p>

<form action=" " className='col-6 m-auto'>
<input className='border-0 rounded-4 form-control' value={signUpData.name}  type="text" placeholder='name' />
<input className='border-0 rounded-4 form-control mt-2'  value={signUpData.email}  type="email" placeholder='email' />
<input className='border-0 rounded-4 form-control mt-2' value={signUpData.phone}  type="tel" placeholder='phone'/>
<input className='border-0 rounded-4 form-control mt-2 col-6' value={signUpData.password}  type="password" placeholder='password' />
<input type="hidden" name="role_id" />


<button className='btn btn-success mt-2'>Submit</button>
</form>


</div>
)}







</div>
</div>

)}


<aside className='col-lg-3 bg-white'>
<ul>
<li>

</li>

</ul>
</aside>



<nav className="navbar navbar-expand-lg   mainNav" style={{zIndex:"10000"}}>
  <div className="container-fluid">
    <Link to="/" className=" text-white fs-3" ><FaTumblr /> </Link>
    <button className="navbar-toggler text-dark " type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon text-light "> <GiHamburgerMenu/></span>
    </button>
    {/* col-md-5 col-sm-5 d-sm-block d-md-block */}
    <div className="collapse navbar-collapse " id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 col-lg-5 mb-lg-0">
      
      
        <form className="d-flex col-lg-12 col-md-10 col-sm-10 ms-2" role="search">
        <input className="form-control search  me-2 border-0 opacity-50" type="search" placeholder="   Search Tumblr" aria-label="Search" />
<span className='position-absolute  fs-4 ps-1 pb-1' style={{color: "rgb(245, 208, 208)"}}><AiOutlineSearch/> </span>
      </form>
       


      </ul>
     
    {isloggedIn===true?( <aside className='justify-content-end navbar-nav '>
    <NavLink  to="/" activeClassName="active"  className=' fs-3 nav-link'
onClick={()=>{
   setCreatePostIsShown(false)}}
    >
<MdHomeFilled />
  </NavLink>

  <NavLink to="/explore"  activeClassName="active" className=' fs-3  nav-link'
 onClick={()=>{
   setCreatePostIsShown(false)}}
  >
<FiCompass/>
  </NavLink>

 

  <NavLink activeClassName="active" className=' fs-3  nav-link'>
  <AiFillShop />
  </NavLink>

<NavLink activeClassName="active" className=' fs-3 nav-link'>
  <GoMail/>
</NavLink>

<NavLink  activeClassName="active" className=' fs-3 nav-link'>
<RiChatSmile3Line/>
</NavLink>

<NavLink activeClassName="active" className=' fs-3 nav-link'>
  <BsFillLightningChargeFill/>
</NavLink>

<NavLink activeClassName="active"  to="/profile" className=' fs-3 nav-link'
 onClick={()=>{
   setCreatePostIsShown(false)}}
>
<CiUser/>
</NavLink>



<button 
onClick={()=>{  handleNewPostPopup()
}}
className='btn btn-primary  border-0  fs-4 pt-1  text-white' style={{backgroundColor:"rgb (0, 184, 255)",color:"rgb(0,25,53)"}}>
 <GrEdit/>
  
</button>
</aside>):
    (
      <div className="d-sm-block d-md-block ">
      <button className="btn login btn-primary  border-0 me-5 fw-bolder text-dark" style={{background:"#00CF35"}} onClick={()=>{
        handleLoginPopup()
        setCreatePostIsShown(false)
      }}>Login</button>


      <button className="btn btn-primary logout  border-0 text-dark " style={{background:"#00B8FF"}}
      onClick={()=>{

        handleSignUpPopup()
        setCreatePostIsShown(false)
      }}
      >Sign up</button>


    </div> 
    )}

   
    </div>
  </div>
 
</nav>
{createPostIsShown&&(

  <main className=' overlay'>
<div className="container text-center popup">
  <div className="row align-items-center">
    <div className="col " >
    <div> <MyModal/></div>
      
    
    </div>
    <div className="col">
     <CreatePostImg/>
    </div>
    <div className="col">
      <CreateQuotePost/>    </div>

      <div className="col">
      <CreateLinkPost/>
    </div>
    <div className="col">
     <CreateHiChatPost/>
    </div>
    <div className="col">
      <CreateAudioPost/>    </div>
      <div className="col">
      <CreateVidPost/>    </div>
  </div>
  </div>

</main>
)



}


</>
  )
}
